import { render, staticRenderFns } from "./CompanySection.vue?vue&type=template&id=7734c4f2"
import script from "./CompanySection.vue?vue&type=script&lang=js"
export * from "./CompanySection.vue?vue&type=script&lang=js"
import style0 from "./CompanySection.vue?vue&type=style&index=0&id=7734c4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports